export default "__VITE_ASSET__CILBld6Y__"